module.exports = __webpack_public_path__ + "images/emoji/heart_decoration.cf36d45b0b49638ee5d1.png";